import { useContext, useState } from "react";
import styles from "./Standard.module.css";
import { Button, Collapsible, Divider, FormLayout, InlineError, Label, RadioButton } from "@shopify/polaris";
import { BundleTypes } from "../constants";
import { asChoiceField } from "@shopify/react-form";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { StandardBundleContext, StandardBundleContextType } from "./Standard";
import RenderSelectedProduct from "../../../components/RenderSelectedProduct/RenderSelectedProduct";
import BundleInfo from "../CommonFields/BundleInfo";
import Discount from "../CommonFields/Discount";
import ComboProductPage from "../../../components/ComboProductPage/ComboProductPage";
import useBundleMixpanelHook from "../../../hooks/useBundleMixpanelHook";
import AllowedProductPages from "../../../components/AllowedProductPages/AllowedProductPages";
import FreeGift from "../../../components/FreeGift/FreeGift";
import TextFields from "../CommonFields/TextFields";
import SwatchesSelectorWrapper from "../CommonFields/SwatchesSelectorWrapper";
import { flattenToVariants, mergeProductsById } from "../../../utilities/functions";

const StandardContentForm = ({ showBundlerLevel = false }: { showBundlerLevel: boolean }) => {
    const [expandProductSetup, setExpandProductSetup] = useState(true);
    const context = useContext(StandardBundleContext);
    const {
        fields: {
            bundle_name,
            title,
            description,
            bundle_product_level,
            products,
            discount_type,
            discount_value,
            order_discounts,
            product_discounts,
            shipping_discounts,
            add_to_cart_cta_text,
            quantity_text,
            footer_total_text,
            footer_text,
            free_text,
            allowed_product_pages,
            render_product_pages_type,
            show_on_no_pages,
            isProductPageVisible,
            allow_free_gifts,
            free_gifts,
            free_gift_text,
            show_swatches,
            swatchOptions,
            swatchesProductsMap,
            swatchShape,
            swatchSize,
            bundle_as_product,
            no_stock_text,
            offer_name,
            discount_label_template,
            show_unit_price_text,
            bundle_as_product: { product_title, product_description, images, double_discount, collections },
            bundles_design: { default_cta },
        },
        handleNext = () => {},
        dispatchBundleConfig,
        bundleConfig,
        submit,
        isMobile,
        SwatchesBundleConfigTouchedRef,
    } = context as StandardBundleContextType;
    const { trackFormSections } = useBundleMixpanelHook();
    console._log("bundle_as_product", bundle_as_product);

    // useEffect(() => {
    //     if (isProductPageVisible.value) {
    //         dispatchBundleConfig({
    //             payload: false,
    //             key: "allow_free_gifts",
    //         });
    //         allow_free_gifts.onChange(false);
    //         dispatchBundleConfig({
    //             payload: [],
    //             key: "free_gifts",
    //         });
    //         free_gifts.onChange([]);
    //     }
    // }, [isProductPageVisible]);

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: "4px" }}>
                <Divider borderColor="border" />
            </div>
            <div className={styles.collapsibleFormBox}>
                <BundleInfo
                    description={description}
                    title={title}
                    bundle_name={bundle_name}
                    bundleType={"standard"}
                    dispatchBundleConfig={dispatchBundleConfig}
                    offer_name={offer_name}
                />

                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>

                <div
                    className={styles.sectionTitleWrapper}
                    onClick={() =>
                        setExpandProductSetup((ps) => {
                            trackFormSections({
                                cta: "Form Section",
                                ctaType: `Product Setup ${ps ? "Collapsed" : "Expanded"}`,
                                bundleType: "standard",
                            });
                            return !ps;
                        })
                    }
                >
                    <div>Product Setup</div>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            transform: expandProductSetup ? "rotate(90deg)" : "rotate(270deg)",
                        }}
                    >
                        <MdOutlineArrowBackIosNew size={14} />
                    </div>
                </div>
                <Collapsible
                    open={expandProductSetup}
                    id="basic-collapsible"
                    transition={{
                        duration: "500ms",
                        timingFunction: "ease-in-out",
                    }}
                    expandOnPrint
                >
                    <FormLayout>
                        {showBundlerLevel && (
                            <div className={styles.customLabelWrapper}>
                                <div className={styles.customLabelWrapper} style={{ marginBottom: "5px" }}>
                                    <Label id="bundle_product_level">Bundle Level</Label>
                                </div>
                            </div>
                        )}
                        {showBundlerLevel && (
                            <div className={`${styles.formCol}`}>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        marginTop: "-5px",
                                    }}
                                >
                                    <RadioButton
                                        label={"Product Level: Variants in Dropdown"}
                                        id="product"
                                        helpText="Selected variants will appear in a dropdown under each product in the bundle."
                                        value="product"
                                        name="bundle_product_level"
                                        {...asChoiceField(bundle_product_level, "product")}
                                        onChange={(status, val) => {
                                            dispatchBundleConfig({
                                                payload: val,
                                                key: "bundle_product_level",
                                            });
                                            const mergedProducts = mergeProductsById(products?.value);
                                            dispatchBundleConfig({
                                                payload: mergedProducts,
                                                key: "products",
                                            });

                                            products.onChange(mergedProducts);
                                            bundle_product_level.onChange(val);
                                        }}
                                    />

                                    <RadioButton
                                        label={"Variant Level: Variants as Standalone"}
                                        id="variant"
                                        helpText="Selected variants will be displayed as individual, standalone products in the bundle."
                                        value="variant"
                                        name="bundle_product_level"
                                        {...asChoiceField(bundle_product_level, "variant")}
                                        onChange={(status, val) => {
                                            dispatchBundleConfig({
                                                payload: val,
                                                key: "bundle_product_level",
                                            });
                                            const flattenProducts = flattenToVariants(products?.value);
                                            dispatchBundleConfig({
                                                payload: flattenProducts,
                                                key: "products",
                                            });
                                            products.onChange(flattenProducts);
                                            bundle_product_level.onChange(val);
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                        <div>
                            <RenderSelectedProduct
                                updateKey={"products"}
                                bundleLevel={bundle_product_level.value}
                                dispatchBundleConfig={dispatchBundleConfig}
                                bundleType={BundleTypes.STANDARD}
                                products={products}
                                submit={submit}
                                isMobile={isMobile}
                                multiple={true}
                                showVariantPicker={true}
                            />
                            <InlineError message={products.error} fieldID="products" />
                            <AllowedProductPages
                                products={[...products.value]}
                                dependencyArr={[products]}
                                validProductPages={allowed_product_pages}
                                dispatchBundleConfig={dispatchBundleConfig}
                                updateKey={"allowed_product_pages"}
                                render_product_pages_type={render_product_pages_type}
                                show_on_no_pages={show_on_no_pages}
                                bundleType={BundleTypes.STANDARD}
                            />
                        </div>
                        <FreeGift
                            dispatchBundleConfig={dispatchBundleConfig}
                            allow_free_gifts={allow_free_gifts}
                            free_gifts={free_gifts}
                            free_gift_text={free_gift_text}
                            submit={submit}
                            excludeProducts={[...products.value]}
                        />

                        <ComboProductPage
                            dispatchBundleConfig={dispatchBundleConfig}
                            isProductPageVisible={isProductPageVisible}
                            submit={submit}
                            product_description={product_description}
                            product_title={product_title}
                            images={images}
                            double_discount={double_discount}
                            collections={collections}
                            bundle_type={"standard"}
                            products={products}
                            default_cta={default_cta}
                        />
                    </FormLayout>
                </Collapsible>

                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>

                <Discount
                    dispatchBundleConfig={dispatchBundleConfig}
                    discount_type={discount_type}
                    discount_value={discount_value}
                    order_discounts={order_discounts}
                    product_discounts={product_discounts}
                    shipping_discounts={shipping_discounts}
                    isMobile={isMobile}
                    bundleType={"standard"}
                    products={products}
                    discount_label_template={discount_label_template}
                    discount_label_template_helptext={""}
                />

                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>

                <SwatchesSelectorWrapper
                    dispatchBundleConfig={dispatchBundleConfig}
                    show_swatches={show_swatches}
                    swatchOptions={swatchOptions}
                    swatchesProductsMap={swatchesProductsMap}
                    swatchShape={swatchShape}
                    swatchSize={swatchSize}
                    productSource={{
                        type: "specific",
                        value: [...(products?.value || []), ...(free_gifts?.value || [])],
                    }}
                    bundleType={BundleTypes.STANDARD}
                    bundleConfig={bundleConfig}
                    SwatchesBundleConfigTouchedRef={SwatchesBundleConfigTouchedRef}
                />

                <div className={styles.dividerStyle}>
                    <Divider borderColor="border" />
                </div>

                <TextFields
                    dispatchBundleConfig={dispatchBundleConfig}
                    add_to_cart_cta_text={add_to_cart_cta_text}
                    default_cta={default_cta}
                    bundleType={BundleTypes.STANDARD}
                    quantity_text={quantity_text}
                    footer_text={footer_text}
                    footer_total_text={footer_total_text}
                    free_text={free_text}
                    no_stock_text={no_stock_text}
                    show_unit_price_text={show_unit_price_text}
                />
            </div>

            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.bottomRowCta}>
                <span></span>
                <Button variant="secondary" onClick={() => handleNext(1, "Design")}>
                    Next
                </Button>
            </div>
        </div>
    );
};

export default StandardContentForm;
